import axios from "axios";
import store from "./store";
import router from "./router";

const ENDPOINT_PATH = "http://api.ingesc.net/cbtis/";

export default {
  async send(data) {
    if (store.state.isLogged) {
      const dataSend = {
        email: store.state.loggedUser.email,
        token: store.state.loggedUser.token,
        ...data,
      };
      try {
        const response = await axios.post(ENDPOINT_PATH + "query.php", dataSend);
        if (response.data.status == 200) {
          store.commit("hideAlert");
          return response.data;
        } else {
          if (response.data.status == 401) {
            router.push("/reconnect");
          }
          return {
            status: response.data.status,
            error: response.data.error,
          };
        }
      } catch (error) {
        console.log(error);
      }
    } else return null;
  },

  async updateUser(data) {
    try {
      const response = await axios.post(ENDPOINT_PATH + "update.php?user", data);
      return response;
    } catch (error) {
      console.log(error);
    }
    return null;
  },
};
